import { useEffect, useState } from 'react';

/**
 * Two-letter browser language (ISO 639-1), resolved after hydration.
 * @arg {string} [fallback='en'] Value used during SSR and when detection fails.
 * @return {string}
 */
export const useBrowserLanguage = (fallback = 'en') => {
  const [lang, setLang] = useState(fallback);

  useEffect(() => {
    if (typeof navigator === 'undefined') {
      return;
    }
    const detected = navigator.language || navigator.userLanguage || '';
    if (detected) {
      setLang(detected.slice(0, 2).toLowerCase());
    }
  }, []);

  return lang;
};
